<template>
	<div class="">
		<Title title="評審故事內容" />
		<el-form :model="editStoryData" label-position="left" label-width="120px">
			<el-form-item>
				<a :href="downloadLink" target="_blank">
					<el-button type="info">下載圖片、分享表、評語</el-button>
				</a>
			</el-form-item>
			<el-form-item label="參加分享">
				<el-tag :type="editStoryData.is_participate ? '' : 'info'">{{editStoryData.is_participate ? "是" : "否"}}</el-tag>
			</el-form-item>
			<el-form-item label="故事帳號">{{editStoryData.account}}</el-form-item>
			<el-form-item label="故事名稱">{{editStoryData.story_name}}</el-form-item>
			<el-form-item label="感受到的問題">{{editStoryData.problem}}</el-form-item>
			<el-form-item label="照片">
				<el-row type="flex" :gutter="20">
					<el-col class="col pointer">
						<div @click="selectImage('feeling')">
							<el-card class="image-card" :body-style="{padding: '0px'}">
								<div class="thumb" :style="`background-image: url(${editStoryData.pictures && mapPicturesCover(editStoryData.pictures.feeling).url})`"></div>
								<div class="caption">
									<b>感受</b>
								</div>
							</el-card>
						</div>
					</el-col>
					<el-col class="col pointer">
						<div @click="selectImage('imagine')">
							<el-card class="image-card" :body-style="{padding: '0px'}">
								<div class="thumb" :style="`background-image: url(${editStoryData.pictures && mapPicturesCover(editStoryData.pictures.imagine).url})`"></div>
								<div class="caption">
									<b>想像</b>
								</div>
							</el-card>
						</div>
					</el-col>
					<el-col class="col pointer">
						<div @click="selectImage('implement')">
							<el-card class="image-card" :body-style="{padding: '0px'}">
								<div class="thumb" :style="`background-image: url(${editStoryData.pictures && mapPicturesCover(editStoryData.pictures.implement).url})`"></div>
								<div class="caption">
									<b>實踐</b>
								</div>
							</el-card>
						</div>
					</el-col>
					<el-col class="col pointer">
						<div @click="selectImage('share')">
							<el-card class="image-card" :body-style="{padding: '0px'}">
								<div class="thumb" :style="`background-image: url(${editStoryData.pictures && mapPicturesCover(editStoryData.pictures.share).url})`"></div>
								<div class="caption">
									<b>分享</b>
								</div>
							</el-card>
						</div>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="故事影片連結">
				<template v-if="youtubeConverter(editStoryData)">
					<div class="youtube">
						<iframe :src="youtubeConverter(editStoryData)" frameborder="0" allowfullscreen />
					</div>
					<a class="video-link" :href="videoHref" target="_blank" rel="noopener">{{ videoUrl }}</a>
				</template>
				<template v-else-if="videoUrl">
					<a class="video-link" :href="videoHref" target="_blank" rel="noopener">{{ videoUrl }}</a>
					<div class="hint">非 YouTube 連結，無法內嵌預覽，請點擊連結另開視窗觀看</div>
				</template>
				<template v-else><b style="color:red;">尚未上傳</b></template>
			</el-form-item>
			<el-form-item label="故事學習單">
				<iframe :src="editStoryData.pdf_list && editStoryData.pdf_list[0].url" frameborder="0" width="600" height="700"></iframe>
			</el-form-item>
			<el-form-item>
				<a :href="downloadLink" target="_blank">
					<el-button type="info">下載圖片、分享表、評語</el-button>
				</a>
			</el-form-item>
		</el-form>
		<div class="score" :class="{'score-open': scoreDialogVisible}">
			<div class="layout-row">
				<div class="score-btn bg-green1 color-white layout-column pointer layout-hv-center" @click="scoreDialogVisible=!scoreDialogVisible">評審表
					<div v-if="scoreDialogVisible">收合</div>
					<div v-else>展開</div>
				</div>
				<ScoreTable :rule-form="editStoryData.judgement"></ScoreTable>
			</div>
		</div>
		<el-dialog class="picture-dialog" :title="selectedPicturesTitle" :visible.sync="dialogPictureVisible">
			<el-carousel :interval="10000" type="card" @change="handlePictureChange">
				<el-carousel-item v-for="(picture, i) in selectedPictures" :key="i" class="center">
					<img :src="picture.url" alt="" width="100%">
				</el-carousel-item>
			</el-carousel>
			<div class="description" v-if="selectedPictures[nowPictureIndex]" v-html="replaceWrapToBr(selectedPictures[nowPictureIndex].description)">
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import ScoreTable from "@/components/backendManage/JudgeStory/ScoreTable";
import { mapState, mapActions } from 'vuex';

export default {
	props: ["id"],
	data() {
		return {
			selectedPictures: [],
			selectedPicturesTitle: "",
			nowPictureIndex: 0,
			dialogPictureVisible: false,
			scoreDialogVisible: true,
			story: {
				youtubeUrl: "https://youtu.be/MMAd3xfVpyc",
				pdfUrl:
					"https://storage-test.dfcchallenge.org/A0013/d4dee711244bf3de7c60dd6a467f5d43.pdf"
			}
		};
	},
	computed: {
		...mapState('story', ['editStoryData']),
		downloadLink() {
			return `${process.env.VUE_APP_API_BASE_URL}${process.env.VUE_APP_API_PORT}/api/story/download/${this.id}`;
		},
		videoUrl() {
			const { youtubeURL, video } = this.editStoryData;
			return youtubeURL || (video && video.src) || "";
		},
		videoHref() {
			// 報名者可能貼沒有協定的網址，直接當 href 會被視為相對路徑
			return this.videoUrl.includes("://") ? this.videoUrl : `https://${this.videoUrl}`;
		},
	},
	methods: {
		...mapActions('story', ['fetchEditStory']),
		youtubeConverter({ youtubeURL, video } = new Object) {
			const url = youtubeURL || (video && video.src) || "";
			const match = url && url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) || null;
			const id = match && match[2] || null
			return id && "https://youtube.com/embed/" + id || false;
		},
		mapPicturesCover(list) {
			return list.find(o => o.is_cover) || list[0];
		},
		selectImage(type) {
			this.selectedPictures = this.editStoryData.pictures[type];
			switch (type) {
				case "feeling": {
					this.selectedPicturesTitle = "感受";
					break;
				}
				case "imagine": {
					this.selectedPicturesTitle = "想像";
					break;
				}
				case "implement": {
					this.selectedPicturesTitle = "實踐";
					break;
				}
				case "share": {
					this.selectedPicturesTitle = "分享";
					break;
				}
			}
			this.dialogPictureVisible = true;
		},
		handlePictureChange(i) {
			this.nowPictureIndex = i;
		},
		replaceWrapToBr(text) {
			return text.replace(/[\r\n]/g, "<br/>");
		},
		handleWordsLength(text, length) {
			if (text.length > length) {
				return text.substring(0, length - 1) + "...";
			}
			return text;
		}
	},
	async created() {
		await this.fetchEditStory(this.id);
	},
	mounted() { },
	components: {
		Title,
		ScoreTable
	}
};
</script>

<style lang="scss" scoped>
.el-form {
	max-width: 900px;
}

.score {
	position: fixed;
	right: -500px;
	top: 10px;
	transition: all 0.4s ease;

	.score-btn {
		width: 30px;
		height: 130px;
		text-align: center;
	}
}

.score-open {
	right: 0;
}

.picture-dialog {
	.description {
		padding: 15px 50px;
		font-size: 14px;
		font-weight: 500;
		line-height: 1.71;
		color: #000;
	}
}

.image-card {
	.thumb {
		width: 100%;
		padding-top: 70%;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	.caption {
		padding: 10px;
	}
}
.video-link {
	word-break: break-all;
}

.hint {
	font-size: 12px;
	line-height: 1.5;
	color: #909399;
}

.youtube {
	position: relative;
	max-width: 100%;

	&::before {
		content: "";
		display: block;
		padding-top: 56.25%;
	}
	iframe {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
	}
}
</style>